// Preference for the breath-synced ambient — a gentle multiplicative gain
// modulation applied on top of the user's current ambient bed so it swells
// on the inhale, holds through the hold, and softens on the exhale.
// Default ON — the range is intentionally narrow (roughly 0.7×–1.25×) so
// the effect reads as a soft tide rather than a volume mixer moving.
// by David Hunt

const KEY = "stillwater.breathSyncAudio";

export const loadBreathSyncPreference = () => {
  try {
    const raw = localStorage.getItem(KEY);
    return raw === null ? true : raw === "true";
  } catch (_) {
    return true;
  }
};

export const saveBreathSyncPreference = (value) => {
  try {
    localStorage.setItem(KEY, String(!!value));
  } catch (_) {
    /* silent */
  }
};
